import * as vp from 'vopay';

import { useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

const initHook = vopayApi.withApiHook(({ api }) => {
  return function useRailzCreateInvoice() {
    const source = axios.CancelToken.source();

    const [response, setResponse] = useState<vp.ApiResponse>();

    const [, setDataFetchingInfo] = useDataFetchIndicator();

    const createInvoice = async (requestParams: vp.RailzCreateInvoiceRequest) => {
      try {
        setDataFetchingInfo(true, 'loading some data', 'fullScreen');
        const res = await api.railzCreateInvoice(requestParams, source);
        setResponse(res);
        return res;
      } finally {
        setDataFetchingInfo(false);
      }
    };
    const reset = () => {
      setResponse(undefined);
    };

    return {
      response,
      createInvoice,
      reset,
    };
  };
});

export default initHook({});
